module.exports = __webpack_public_path__ + "media/icons/plus-hexagon-18da1e4d.svg";